/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import AqaTableQualityDefinition from './AqaTableQualityDefinition';
import AqaVectorQualityDefinitionTable from './AqaVectorQualityDefinitionTable';

/**
 * The AqaQualityDefinition model module.
 * @module model/AqaQualityDefinition
 * @version v0
 */
export default class AqaQualityDefinition {
  /**
   * Constructs a new <code>AqaQualityDefinition</code>.
   * @alias module:model/AqaQualityDefinition
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>AqaQualityDefinition</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AqaQualityDefinition} obj Optional instance to populate.
   * @return {module:model/AqaQualityDefinition} The populated <code>AqaQualityDefinition</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new AqaQualityDefinition();
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'String');
      if (data.hasOwnProperty('sourceId'))
        obj.sourceId = ApiClient.convertToType(data['sourceId'], 'String');
      if (data.hasOwnProperty('originalSourceId'))
        obj.originalSourceId = ApiClient.convertToType(data['originalSourceId'], 'String');
      if (data.hasOwnProperty('originalAccountId'))
        obj.originalAccountId = ApiClient.convertToType(data['originalAccountId'], 'String');
      if (data.hasOwnProperty('name'))
        obj.name = ApiClient.convertToType(data['name'], 'String');
      if (data.hasOwnProperty('timestamp'))
        obj.timestamp = ApiClient.convertToType(data['timestamp'], 'Number');
      if (data.hasOwnProperty('originalTimestamp'))
        obj.originalTimestamp = ApiClient.convertToType(data['originalTimestamp'], 'Number');
      if (data.hasOwnProperty('vectorQualityTable'))
        obj.vectorQualityTable = AqaVectorQualityDefinitionTable.constructFromObject(data['vectorQualityTable']);
      if (data.hasOwnProperty('tableQuality'))
        obj.tableQuality = AqaTableQualityDefinition.constructFromObject(data['tableQuality']);
      if (data.hasOwnProperty('subscriptionQdId'))
        obj.subscriptionQdId = ApiClient.convertToType(data['subscriptionQdId'], 'String');
      if (data.hasOwnProperty('subscriptionId'))
        obj.subscriptionId = ApiClient.convertToType(data['subscriptionId'], 'String');
    }
    return obj;
  }
}

/**
 * @member {String} id
 */
AqaQualityDefinition.prototype.id = undefined;

/**
 * @member {String} sourceId
 */
AqaQualityDefinition.prototype.sourceId = undefined;

/**
 * @member {String} originalSourceId
 */
AqaQualityDefinition.prototype.originalSourceId = undefined;

/**
 * @member {String} originalAccountId
 */
AqaQualityDefinition.prototype.originalAccountId = undefined;

/**
 * @member {String} name
 */
AqaQualityDefinition.prototype.name = undefined;

/**
 * @member {Number} timestamp
 */
AqaQualityDefinition.prototype.timestamp = undefined;

/**
 * @member {Number} originalTimestamp
 */
AqaQualityDefinition.prototype.originalTimestamp = undefined;

/**
 * @member {module:model/AqaVectorQualityDefinitionTable} vectorQualityTable
 */
AqaQualityDefinition.prototype.vectorQualityTable = undefined;

/**
 * @member {module:model/AqaTableQualityDefinition} tableQuality
 */
AqaQualityDefinition.prototype.tableQuality = undefined;

/**
 * @member {String} subscriptionQdId
 */
AqaQualityDefinition.prototype.subscriptionQdId = undefined;

/**
 * @member {String} subscriptionId
 */
AqaQualityDefinition.prototype.subscriptionId = undefined;

